import(/* webpackMode: "eager", webpackExports: ["CTASection"] */ "/vercel/path0/app/(marketing)/_components/cta-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DemoSection"] */ "/vercel/path0/app/(marketing)/_components/demo-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DeveloperSection"] */ "/vercel/path0/app/(marketing)/_components/developer-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/vercel/path0/app/(marketing)/_components/faq-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturesSection"] */ "/vercel/path0/app/(marketing)/_components/features-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroImageSection"] */ "/vercel/path0/app/(marketing)/_components/hero-image-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/vercel/path0/app/(marketing)/_components/hero-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IntegrationsSection"] */ "/vercel/path0/app/(marketing)/_components/integrations-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PricingSection"] */ "/vercel/path0/app/(marketing)/_components/pricing-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HowItWorksSection","StatsSection"] */ "/vercel/path0/app/(marketing)/_components/steps-stats-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WhatsNewSection"] */ "/vercel/path0/app/(marketing)/_components/whats-new-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturedOn"] */ "/vercel/path0/app/(marketing)/featured/_components/Featuredon.tsx");
